var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 606.45 408.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002201;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 408.11 0 34.37 88.46 120.3 100.8 48.43 125.77 112.49 190.27 0 236.45 105.14 269.45 62.14 294.45 105.14 341.45 25.14 359.37 107.8 424.45 11.14 479.84 128.11 528.45 50.14 541.19 143.75 606.45 39.14 606.45 408.11 544.12 408.11 507.45 241.14 101.45 239.14 53.5 408.11 0 408.11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset20);
export default __webpack_public_path__ + "static/media/Asset 20.b660f4b2.svg";
export { ForwardRef as ReactComponent };